import React from "react";

// Status Badge Component with colorful rounded format and shadow
const StatusBadge = ({ status }) => {
  const getStatusColor = (status) => {
    switch(status.toLowerCase()) {
      case "active":
      case "confirmed":
        return { bg: "#d4edda", text: "#155724" };
      case "inactive":
      case "canceled":
      case "cancelled":
        return { bg: "#f8d7da", text: "#721c24" };
      case "pending":
        return { bg: "#fff3cd", text: "#856404" };
      default:
        return { bg: "#e2e3e5", text: "#383d41" };
    }
  };

  const colors = getStatusColor(status);

  return (
    <span
      className="status-badge"
      style={{
        backgroundColor: colors.bg,
        color: colors.text,
        padding: "6px 12px",
        borderRadius: "20px",
        fontSize: "14px",
        fontWeight: "500",
        display: "inline-block",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
      }}
    >
      {status}
    </span>
  );
};

export default StatusBadge;
